import React from "react";

const CommissionList = () => {
  return <div>CommissionList</div>;
};

export default CommissionList;
